
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 2118 1921.8","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"escena_x5F_path"}},[_c('path',{attrs:{"id":"escenario_x5F_5_x5F_path","d":"M2117.3 610.4L1058.4-.2-.5 611.2l.1 698.6.1.4 1058.8 611v.1h.1l.1.1v-.1L2117.5 1310v-.1h.1V610.4h-.3z","opacity":".15","fill":"#fff"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_16","fill":"rgba(10,10,10,0.2)","d":"M850.9 1162.4h337v345.4h-337z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_17","fill":"rgba(10,10,10,0.2)","d":"M422.2 1116.3h364.3v188.2H422.2z"}}),_c('path',{staticClass:"st1 activity",attrs:{"id":"act_18","fill":"rgba(10,10,10,0.2)","d":"M377.5 850.4h385.8v245.1H377.5z"}})])])
          )
        }
      }
    